export default {
  namespaced: true,
  state: {
    items: [],
    page: null,
    isLastPage: false,
    item: null,
    isLimited: false,
  },
  getters: {
    getTalks(state) {
      return state.items
    },
    getBeforeTalk(state) {
      return state.item
    },
    getPaging(state) {
      return {
        page: state.page,
        isLastPage: state.isLastPage,
        isLimited: state.isLimited
      }
    },
  },
  mutations: {
    loadPage(state, { page, data }) {
      // 너무 많아지는 경우 대비해서 limit
      const limitCount = 200
      state.items = state.items.concat(data.results)
      console.log(state.items.length)
      if (state.items.length > limitCount) {
        state.isLimited = true
        state.items.splice(0, state.items.length - limitCount)
      }

      state.page = page
      state.isLastPage = data.next == null
    },
    clear(state) {
      state.items.splice(0, state.items.length)
      state.page = null
      state.isLastPage = false
      state.item = null
      state.isLimited = false
    },
    clearItem(state) {
      state.item = null
    },
    setItem(state, item) {
      state.item = item
    },
    updateItem(state, newItem) {
      const itemIndex = state.items.findIndex(item => newItem.uuid === item.uuid)
      if (itemIndex !== -1) {
        state.items.splice(itemIndex, 1, newItem)
      }
    },
  },
  actions: {
    clear({ commit }) {
      commit('clear')
    },
    clearItem({ commit }) {
      commit('clearItem')
    },
    loadPage({ commit }, { page, data }) {
      commit('loadPage', { page, data })
    },
    setItem({ commit }, item) {
      // 상세페이지 들어왔을 때 set
      commit('setItem', item)
    },
    updateItem({ commit }, item) {
      // items에서 item 찾아 변경
      commit('updateItem', item)
    },
  }
}
